import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../components/PageTitle';

const ProductsPage = () => {
    const navigate = useNavigate();
    const categories = [
        {
            name: 'Instrumentation & Automation',
            slug: 'instrumentation',
            description: 'Explore our comprehensive range of cutting-edge instrumentation and automation products for industrial applications.',
            image: '/images/products/instrumentation/HMI-Touch-Screen.webp'
        },
        {
            name: 'Electrical',
            slug: 'electrical',
            description: 'Discover our innovative electrical solutions designed for reliability, efficiency, and safety in various industrial settings.',
            image: '/images/products/electrical/AVR.webp'
        },
        {
            name: 'Wireless',
            slug: 'wireless',
            description: 'Advanced wireless communication solutions for industrial automation and monitoring systems.',
            image: '/images/products/wireless/RTC1.webp'
        },
        {
            name: 'Laboratory',
            slug: 'laboratory',
            description: 'High-precision laboratory equipment and analytical instruments for research and quality control.',
            image: '/images/products/laboratory/Analytical-Instruments-1.webp'
        },
        {
            name: 'Display',
            slug: 'display',
            description: 'State-of-the-art display solutions for industrial monitoring and control systems.',
            image: '/images/products/display/variable-display.webp'
        },
        {
            name: 'Microwave Moisture Sensors',
            slug: 'microwave-moisture-sensors',
            description: 'Advanced microwave moisture measurement technology for precise material analysis.',
            image: '/images/products/microwave/CONCRETE-AND-CONSTRUCTION.webp'
        },
        {
            name: 'X-Ray',
            slug: 'x-ray',
            description: 'Industrial X-ray systems for non-destructive testing and quality control applications.',
            image: '/images/products/xray/X_ray-Presentation.webp'
        },
        {
            name: 'NIR',
            slug: 'nir',
            description: 'Near-Infrared spectroscopy solutions for material analysis and process control.',
            image: '/images/products/nir/NIR-Jiotronik.webp'
        }
    ];

    return (
        <div className="bg-white text-gray-800">
            <PageTitle title="Our Products" breadcrumbs="Home > Products" />
            <section className="py-16 md:py-24">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto text-lg leading-relaxed">
                        Explore our comprehensive range of products designed to meet your industrial and commercial needs.
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {categories.map((category) => (
                            <div
                                key={category.slug}
                                className="bg-gray-50 rounded-xl shadow-xl overflow-hidden flex flex-col group transform hover:scale-105 transition-all duration-300 border border-gray-200 hover:border-yellow-500 cursor-pointer"
                                onClick={() => navigate(`/products/${category.slug}`)}
                            >
                                <div className="relative overflow-hidden h-52">
                                    <img
                                        src={category.image}
                                        alt={category.name}
                                        className="w-full h-full object-cover transition-transform duration-500"
                                    />
                                </div>
                                <div className="p-6 flex flex-col flex-grow">
                                    <h3 className="text-xl font-semibold text-gray-800 mb-2">{category.name}</h3>
                                    <p className="text-gray-600 text-sm mb-4 flex-grow leading-relaxed">
                                        {category.description}
                                    </p>
                                    <button
                                        className="mt-auto text-center text-yellow-600 hover:text-yellow-700 font-semibold py-2 px-4 rounded-md text-sm transition-colors duration-300 border border-yellow-500 hover:bg-yellow-50"
                                    >
                                        View Products
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ProductsPage;